import React from 'react';
import { motion } from 'framer-motion';
const tools = ['Class Finder — locate any class instantly by level, duration, objective, skill, musicality, freestyle, choreography, performance, group energy, or emergency need', '45, 60, and 75-minute class formats — adapt any session to your available time without rebuilding it', 'Weekly and monthly planners — organize your program from the first class to the last', 'Student skill tracking sheets — monitor individual and group progress over time', 'Attendance register — keep records organized and ready', 'Evaluation tools — assess foundations, technique, musicality, freestyle, and performance readiness', 'Instructor notes — document what works, what to adjust, and what to repeat'];
export function ToolkitSection() {
  return <section className="py-24 px-4 bg-cream-dark border-y border-line" data-id="element-308" data-mp="1pdb2o2rctsf3">
      <div className="max-w-4xl mx-auto" data-id="element-309" data-mp="1ubuom35y747g">
        <div className="text-center mb-10" data-id="element-310" data-mp="1uatec0wralqs">
          <h2 className="text-3xl md:text-4xl font-serif font-bold uppercase mb-3 text-ink" data-id="element-311" data-mp="1udpbvo4oz8ep">
            🛠️ Component 6 — The Full Instructor Toolkit
          </h2>
          <p className="text-ink-soft" data-id="element-312" data-mp="3qbnp5afho2f3">
            Built into the system so you never have to figure out the logistics
            on your own.
          </p>
        </div>

        <div className="space-y-3" data-id="element-313" data-mp="3hah912gr4tmd">
          {tools.map((tool, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="flex items-start gap-3 bg-cream-light border border-line rounded-xl p-4 shadow-sm" data-id="element-314" data-mp="3cal6l7npda8x" data-mpi={i}>
              <span className="text-gold-dark leading-none mt-1" aria-hidden="true" data-id="element-315" data-mp="2ykrfeioq6dw1">
                ✦
              </span>
              <span className="text-ink-soft text-sm leading-relaxed" data-id="element-316" data-mp="2tm6ba86cra2b">
                {tool}
              </span>
            </motion.div>)}
        </div>

        <p className="text-center text-lg text-ink mt-10 font-medium max-w-2xl mx-auto" data-id="element-317" data-mp="2ewliivb76wdt">
          This is the infrastructure that turns 100 individual classes into one{' '}
          <span className="text-burgundy font-bold" data-id="element-318" data-mp="24zqnime4ve4a">
            complete, professional program.
          </span>
        </p>
      </div>
    </section>;
}